import type { Poll, VoteResult } from '../types';

const ALLOWED_CHARS = 'abcdefghijkmnpqrstuvwxyz23456789';

export function generatePollCode(): string {
  let code = '';
  for (let i = 0; i < 4; i++) {
    code += ALLOWED_CHARS.charAt(Math.floor(Math.random() * ALLOWED_CHARS.length));
  }
  return code;
}

export function normalizePollCode(code: string): string {
  return code.toLowerCase().trim();
}

export function calculateResults(poll: Poll): VoteResult[] {
  const results: VoteResult[] = poll.candidates.map(candidate => {
    let upvotes = 0;
    let downvotes = 0;
    
    Object.values(poll.votes).forEach(userVotes => {
      if (userVotes[candidate.id] === true) upvotes++;
      if (userVotes[candidate.id] === false) downvotes++;
    });

    return {
      candidateId: candidate.id,
      candidateName: candidate.name,
      upvotes,
      downvotes,
      total: upvotes - downvotes
    };
  });

  return results.sort((a, b) => b.total - a.total);
}

export function hasDuplicateCandidates(candidates: string[]): boolean {
  const normalized = candidates
    .map(c => c.trim().toLowerCase())
    .filter(c => c !== '');
  return new Set(normalized).size !== normalized.length;
}